/** @format */
import { safeObjectFit } from '@mpb-com/feather/helpers/styles';
import { css } from 'styled-components';

import { smallMobile, smallTablet } from '@toucan/client/global/application';
import { theme } from '@toucan/client/global/theme';

import { StyledBaseSummaryItemProps } from './types';

const baseStyles = ({ hasTitleLink }: StyledBaseSummaryItemProps) => css`
    margin-bottom: var(--layout-spacing-12);
    padding: var(--layout-spacing-12);
    color: var(--colors-text-secondary);
    text-align: left;
    box-shadow: var(--effects-shadow-base);
    border-radius: 0.8rem;
    list-style: none;

    .content {
        display: flex;
        flex: 0 1 100%;
    }

    .price-and-actions {
        display: flex;
        flex-direction: column;
        align-items: flex-end;
        flex-shrink: 0;
        margin-left: var(--layout-spacing-16);
        gap: var(--layout-spacing-8);

        .action-buttons {
            display: flex;
            align-items: flex-end;
            gap: var(--layout-spacing-8);
        }
    }

    .price {
        display: grid;
        grid-template-columns: auto auto;
        grid-column-gap: 0.4rem;
        grid-row-gap: 0.8rem;
        align-items: center;
        text-align: right;
        flex-shrink: 0;
        ${theme.typography.body_small};

        p {
            white-space: nowrap;
            ${theme.typography.body_normal_highlight}
        }

        div {
            flex-shrink: 0;
            white-space: nowrap;
            display: flex;
        }

        .skeleton {
            width: 4.8rem;
            height: 3rem;
        }
    }

    .information {
        display: flex;
        align-items: flex-start;
        flex-grow: 1;
        min-width: 0;
    }

    .image {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-right: var(--layout-spacing-12);
        flex-shrink: 0;
        position: relative;
        cursor: ${hasTitleLink ? 'pointer' : 'default'};

        img {
            width: 6.4rem;
            height: 4.8rem;
            ${safeObjectFit('contain')}

            ${smallTablet(css`
                width: 4.8rem;
                height: 3.6rem;
            `)};
        }
    }

    .sku {
        ${theme.typography.caption}
        color: var(--colors-text-primary);

        .sku-suffix {
            text-transform: uppercase;
        }
    }

    .title-text {
        margin-bottom: var(--layout-spacing-8);
    }

    .title-and-desc {
        flex-grow: 1;
        overflow: hidden;
        overflow-wrap: break-word;
    }

    .description {
        ${theme.typography.body_small}
        strong {
            ${theme.typography.body_small_highlight};
        }
    }

    p {
        margin: 0;
    }

    ${smallMobile(css`
        .content {
            flex-direction: column;
            position: relative;
        }

        .image {
            flex-direction: row;
        }

        .price-and-actions {
            position: absolute;
            top: 0;
            right: 0;
            flex-direction: column-reverse;
        }

        .information {
            margin-top: var(--layout-spacing-12);
        }
    `)}
`;

const disabledStyles = ({ disabled }: StyledBaseSummaryItemProps) => {
    if (disabled) {
        return css`
            .image,
            .title-and-desc,
            .price {
                opacity: 0.5;
            }
        `;
    }

    return css``;
};

export const styles = (props: StyledBaseSummaryItemProps) => css`
    ${baseStyles(props)}
    ${disabledStyles(props)}
`;
